module.exports = __webpack_public_path__ + "images/category_lp/construction_equipment/store_images/4_612dccd469e9e4f5b54303f5ae44f776.png";